import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useRouter } from "next/router";
import { next, previous } from "../../utils/loop";
import { useVideo } from "./hooks";
import { useMapBounds } from "@parkschannel/map";
import { useAnalytics } from "../../utils";
export const VideoModalContext = /*#__PURE__*/ createContext({
    nextVideo: null,
    previousVideo: null,
    selectedVideo: null,
    setSelectedVideoAndUrl: ()=>null,
    setSelectedVideo: ()=>null
});
export const useVideoModalContext = ()=>useContext(VideoModalContext);
export const VideoModalProvider = (param)=>{
    let { children , initialVideo  } = param;
    const { onModalOpen  } = useAnalytics();
    const [selectedVideo, setSelectedVideo] = useState(initialVideo !== null && initialVideo !== void 0 ? initialVideo : null);
    const router = useRouter();
    const { useVideoListQuery  } = useVideo();
    const { mapBounds , zoom  } = useMapBounds();
    const { data: videoList  } = useVideoListQuery(mapBounds, zoom);
    const handleChangeVideo = useCallback((video)=>{
        setSelectedVideo(video);
        if (video && video.title) {
            onModalOpen("videoModal", {
                video_id: video.id,
                video_title: video.title
            });
        }
    }, []);
    const handleChangeVideoAndUrl = useCallback((video)=>{
        handleChangeVideo(video);
        void router.push({
            query: {
                slug: video === null || video === void 0 ? void 0 : video.slug
            }
        }, undefined, {
            shallow: false
        });
    }, []);
    const nextVideo = useMemo(()=>{
        return videoList && next(videoList.videos, selectedVideo, (currentItem, otherItem)=>{
            return (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id) === (otherItem === null || otherItem === void 0 ? void 0 : otherItem.id);
        });
    }, [
        selectedVideo,
        videoList
    ]);
    const previousVideo = useMemo(()=>{
        return videoList && previous(videoList.videos, selectedVideo, (currentItem, otherItem)=>{
            return (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id) === (otherItem === null || otherItem === void 0 ? void 0 : otherItem.id);
        });
    }, [
        selectedVideo,
        videoList
    ]);
    return /*#__PURE__*/ _jsx(VideoModalContext.Provider, {
        value: {
            selectedVideo,
            setSelectedVideo: handleChangeVideo,
            setSelectedVideoAndUrl: handleChangeVideoAndUrl,
            nextVideo: nextVideo,
            previousVideo: previousVideo
        },
        children: children
    });
};
export const VideoModalConsumer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(VideoModalContext.Consumer, {
        children: (value)=>children(value)
    });
};
